import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ICompany } from 'src/app/interfaces/company';
import { ErrorsService } from 'src/app/services/common/errors.service';
//import * as moment from "jalali-moment";

import { IConfirm } from 'src/app/interfaces/confirm';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IBranch } from 'src/app/interfaces/branch';
import { MarkTypeEntryComponent } from '../mark-type-entry/mark-type-entry.component';
import { MarkManagementService } from 'src/app/services/http/business/markManagement/mark-management.service';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';

@Component({
  selector: 'app-mark-type-list',
  templateUrl: './mark-type-list.component.html',
  styleUrls: ['./mark-type-list.component.css']
})
export class MarkTypeListComponent implements OnInit {

  param: any;
  errObject: any;
  isOwner: boolean;
  errors = new Array();
  pageSize: number;
  pageIndex: number;
  companyList: ICompany;
  branchList: IBranch;
  companySelected: String;
  CompanyEncryptId: string;
  filter: any;
  queryParams: any;
  eduPackageList: IEducationPackage;

  displayedColumns: string[] = [
    "MarkTypeTitle",
    "Package",
    "Coefficient",
    "status",
    'function'
  ];
  dataSource = new MatTableDataSource();
  

  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private eduPackageService: EducationPackageService,
    private errorService: ErrorsService,
    private markManagementService: MarkManagementService,
    private dialogRef: MatDialogRef<MarkTypeListComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit() {
    this.getEduPackage();
    this.queryParams={
      markTypeId:this.data.Id
    };
   
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }
  

  setParamsList(id) {
   
    //Id => EducationPackage
    this.queryParams["Id"]=id;
    this.refresh();
  }

  getColor(e) {
    switch (e.IsActive) {
      case true:
        return "custom-chips primary";
      case false:
        return "custom-chips accent";
    }
  }
  // get list mark-type
  refresh() {
    this.markManagementService.list(this.queryParams).subscribe(res => {
     
      this.dataSource = res;
    });
  }

  // create mark-type 
  add() {
    this.dialog.open(MarkTypeEntryComponent,{
      data:{
        MarkTypeCatId : this.data.Id,
        IsUpdate : false
      } ,
      disableClose: true
    })
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }
  // update mark-type 
  edit(param: any) {
   
    param["MarkTypeCatId"]=this.data.Id;
    param["IsUpdate"]=true;
    this.dialog.open(MarkTypeEntryComponent, {
      data: param,
      disableClose: true
    })
      .afterClosed().subscribe(() => {
        this.refresh();
      });
  }

  delete(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.category")
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.markManagementService.delete({ Id: data.Id }).subscribe(() => {
             
              this.snackBar.OpenSnackBar(
                this.translate.get("success.delete"),
                "ok",
                5000,
                SoundEnum.beep
              );
              this.refresh();
            }, () => {

              this.snackBar.OpenSnackBar(
                this.translate.get("error.delete"),
                "ok",
                5000,
                SoundEnum.beep
              );

            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }
  
  onNoClick() {
    this.dialogRef.close();
  }
}
